<template>
  <div class="" :class="{ processing: loadingGarments.length == 0 }">
    <UButton
      color="white"
      icon="i-heroicons-trash-20-solid"
      class="absolute top-4 right-4 z-[9999] opacity-0 group-hover:opacity-100"
    />

    <UButton
      color="white"
      icon="i-heroicons-cloud-arrow-down-20-solid"
      class="absolute top-4 left-4 z-[9999] opacity-0 group-hover:opacity-100"
    />

    <a draggable="false" href="`/detail/${image.pathname.split('.')[0]}`">
      <img
        draggable="false"
        :src="mainImageSrc"
        class="h-auto w-full max-h-[1430px] rounded-md transition-all duration-200 border-image brightness-[.8] hover:brightness-100 will-change-[filter] object-cover"
      />

      <div class="glowtwo wipe"></div>
      <div class="glowspark"></div>
    </a>
    <div
      class="absolute p-2 w-full h-full top-0 flex items-end gap-2"
      ref="listRef"
    >
      <UCard
        v-for="garment in garments"
        :key="garment.key"
        :ui="{
          background: 'dark:bg-[#1e1f21]',
          ring: 'ring-0',
          base: 'rounded-lg overflow-hidden h-28 w-20',
          body: 'px-0 py-0',
        }"
        :class="{
          'selected-card-two':
            selectedGarment && selectedGarment.id === garment.id,
          'gradient-border-anim': false,
        }"
        @click="selectGarment(garment)"
      >
        <!-- Photo of the garment -->
        <div class="h-20">
          <img
            draggable="false"
            :src="garment.imageUrl"
            alt="Garment Photo"
            class="object-cover w-full h-full p-0 dark:bg-[#1e1f21]"
          />
        </div>

        <!-- Garment data in the footer -->
        <template #footer>
          <div class="p-0">
            <h3 class="text-[9px] font-semibold">{{ garment.name }}</h3>
          </div>
        </template>
      </UCard>
    </div>
  </div>
</template>
<script setup>
import { dragAndDrop } from "@formkit/drag-and-drop/vue";
import {
  parents,
  parentValues,
  dragValues,
  setParentValues,
  handleDragoverParent,
  handleEnd,
} from "@formkit/drag-and-drop";
const props = defineProps({
  image: Object,
});

const findDuplicates = (values) => {
  const uniqueElements = new Set();
  const duplicates = [];

  values.forEach((item) => {
    if (uniqueElements.has(item)) {
      duplicates.push(item);
    } else {
      uniqueElements.add(item);
    }
  });

  return duplicates;
};

function targetTransfer(state, data) {
  const draggedValues = dragValues(state);

  const targetParentValues = parentValues(
    data.targetData.parent.el,
    data.targetData.parent.data
  );

  /*const lastParentValues = parentValues(
    state.lastParent.el,
    state.lastParent.data
  ).filter((x) => !draggedValues.includes(x));*/

  //setParentValues(state.lastParent.el, state.lastParent.data, lastParentValues);

  //alert(JSON.stringify(targetParentValues));

  // Check for duplicates before performing the transfer
  const existingKeys = targetParentValues.map((item) => item.key);
  const newItems = draggedValues.filter(
    (item) => !existingKeys.includes(item.key)
  );

  if (newItems.length === 0) {
    //targetIndex = state.initialIndex;
    return; // Prevent transfer if all items are already present
  }

  const reset =
    state.initialParent.el === data.targetData.parent.el &&
    data.targetData.parent.data.config.sortable === false;

  //alert(state.initialParent.el === data.targetData.parent.el);

  let targetIndex;

  if ("node" in data.targetData) {
    if (reset) {
      targetIndex = state.initialIndex;
    } else if (data.targetData.parent.data.config.sortable === false) {
      targetIndex = data.targetData.parent.data.enabledNodes.length;
    } else {
      targetIndex = data.targetData.node.data.index;
    }

    targetParentValues.splice(targetIndex, 0, ...draggedValues);
  } else {
    targetIndex = reset
      ? state.initialIndex
      : data.targetData.parent.data.enabledNodes.length;

    targetParentValues.splice(targetIndex, 0, ...draggedValues);
  }

  const duplicates = findDuplicates(targetParentValues);

  for (const duplicate of duplicates) {
    if (!("key" in duplicate) || typeof duplicate !== "object") continue;
    const index = targetParentValues.indexOf(duplicate);
    const newKey = `${duplicate.key}-${Math.random()
      .toString(36)
      .substring(2, 15)}`;

    //alert(newKey);

    targetParentValues[index] = {
      ...targetParentValues[index],
      key: newKey,
    };
  }

  setParentValues(
    data.targetData.parent.el,
    data.targetData.parent.data,
    targetParentValues
  );
}

const targetClone = (parent) => {
  const parentData = parents.get(parent);

  if (!parentData) return;

  return {
    setup() {
      parentData.config.performTransfer = targetTransfer;
    },
  };
};

const mainImageSrc = ref(`/images/${props.image.pathname}`);
const loadingGarments = ref([]);
const processedGarments = ref([]);
const selectedGarment = ref(null);
const garments = ref([]);
const listRef = ref();
dragAndDrop({
  parent: listRef,
  values: garments,
  // dropZone: true,
  group: "garments",
  handleDragoverParent: function (event) {
    console.log(event);
    handleDragoverParent(event);
  },
  handleEnd: function (event) {
    alert("hello");
    handleEnd(event);
  },
  // sortable: true,
  // dropZoneClass: "dragging",
  plugins: [targetClone],
});

watch(garments, async (newGarments, oldGarments) => {
  const addedGarments = newGarments.filter(
    (newGarment) =>
      !oldGarments.some((oldGarment) => oldGarment.id === newGarment.id)
  );
  for (const garment of addedGarments) {
    await processGarment(garment);
  }
});

async function processGarment(garment) {
  loadingGarments.value.push(garment.id);
  try {
    const response = await fetch("/api/process-garment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ garment, image: props.image.pathname }),
    });
    const data = await response.json();
    processedGarments.value.push({ id: garment.id, url: data.output_url });
  } catch (error) {
    console.error("Error processing garment:", error);
  } finally {
    /* loadingGarments.value = loadingGarments.value.filter(
      (id) => id !== garment.id
    );*/
  }
}

const selectGarment = (garment) => {
  selectedGarment.value = garment;
  // Simulate sending the image to the AI and receiving a new image URL
  mainImageSrc.value = `/images/processed/${garment.key}.jpg`;
};
</script>
<style scoped lang="postcss">
.dragging {
  border: 2px dashed #4b5563 !important;
  background-color: #2d3748 !important;
  border-radius: 0.375rem !important;
  transition: border-color 0.2s ease !important;
}
.selected-card {
  border: 1px solid #4b5563; /* Customize the color as needed */
}
.gradient-border-anim {
  --borderWidth: 1px;
  background: #1d1f20;
  position: relative;
  border-radius: var(--borderWidth);
}
.gradient-border-anim:after {
  content: "";
  position: absolute;
  top: calc(-1 * var(--borderWidth));
  left: calc(-1 * var(--borderWidth));
  height: calc(100% + var(--borderWidth) * 2);
  width: calc(100% + var(--borderWidth) * 2);
  background: linear-gradient(
    60deg,
    #f79533,
    #f37055,
    #ef4e7b,
    #a166ab,
    #5073b8,
    #1098ad,
    #07b39b,
    #6fba82
  );
  border-radius: calc(2 * var(--borderWidth));
  z-index: -1;
  animation: animatedgradient 3s ease alternate infinite;
  background-size: 300% 300%;
}

@keyframes animatedgradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.glowcontainer {
  width: 300px;
  height: 450px;
  background: gray;

  position: relative;
}
.glowspark {
  border-radius: 5px;
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  filter: blur(9px);
  mix-blend-mode: multiply;
  opacity: 1;
  transition: all 0.5s;
}

.processing .glowspark {
  opacity: 0;
}

.glowspark:after {
  content: "";
  position: absolute;
  background: #fff;
  inset: 10px;
  border-radius: 5px;
}

.glowspark::before {
  content: "";
  width: 200%;

  aspect-ratio: 1;
  inset: 50% auto auto 50%;
  position: absolute;
  translate: -50% -50%;
  animation: lazy 6s infinite linear;
  background: conic-gradient(
    transparent,
    rgba(0, 0, 255, 1) 90deg,
    transparent 180deg
  );
}

@keyframes lazy {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.glowtwo {
  width: 400px;
  height: 250px;
  border-radius: 5px;
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;

  box-shadow: inset 0 0 50px rgba(255, 0, 255, 0.5),
    inset 0 0 100px rgba(0, 0, 255, 0.5), inset 0 0 150px rgba(255, 0, 255, 0.5);

  transition: all 0.5s;
}

.processing .glowtwo {
  box-shadow: inset 0 0 0px rgba(255, 0, 255, 0.5),
    inset 0 0 0px rgba(0, 0, 255, 0.5), inset 0 0 0px rgba(255, 0, 255, 0.5);
}

.glowtwo:before {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  filter: blur(20px);
  border: 15px solid;
  border-image: linear-gradient(
      90deg,
      rgba(255, 0, 255, 1),
      rgba(0, 0, 255, 1),
      rgba(255, 0, 255, 1)
    )
    10;

  transition: all 0.5s;
}

.processing .glowtwo:before {
  border: 0;
}

.glow {
  width: 800px;
  height: 450px;
  background: black;
  overflow: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;

  box-shadow: inset 0 0 50px rgba(255, 0, 255, 0.5),
    inset 0 0 100px rgba(0, 0, 255, 0.5), inset 0 0 150px rgba(255, 0, 255, 0.5);
}

.glow:before {
  content: "";
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  background: linear-gradient(
    90deg,
    rgba(255, 0, 255, 1),
    rgba(0, 0, 255, 1),
    rgba(255, 0, 255, 1)
  );
  z-index: 1;
  filter: blur(30px);
}

.glow:after {
  content: "";
  position: absolute;
  top: 5%;
  left: 5%;
  right: 5%;
  bottom: 5%;
  background: black;
  filter: blur(50px);
  z-index: 2;
}

.wipe {
  transition: all 600ms cubic-bezier(0, 0.55, 0.45, 1);
}
</style>
